export default __webpack_public_path__ + "static/media/singleCard.66fe9c0b.svg";